import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { AccountSettingsMenu } from '../../AccountSettings/AccountSettingsMenu';

interface MenuItemType {
    name: string;
    route: string;
}

interface AccountSettingsLayoutProps {
    menuItems: MenuItemType[];
}

const AccountSettingsLayout: React.FC<AccountSettingsLayoutProps> = ({ menuItems }) => {
    const navigate = useNavigate();

    const handleMenuItemClick = (route: string) => {
        navigate(route);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                mt: 3,
                gap: 2,
            }}>
            <CssBaseline />

            {/* Menu Area */}
            <Box
                sx={{
                    maxWidth: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                }}>
                <AccountSettingsMenu menuItems={menuItems} onItemClick={item => handleMenuItemClick(item.route)} />
            </Box>

            {/* Content Area */}
            <Box
                sx={{
                    flexGrow: 1,
                    p: {
                        xs: 2,
                        lg: 4,
                    },
                    borderRadius: 2,
                    width: '100%',
                    minHeight: '100vh',
                }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export { AccountSettingsLayout };
